import { css } from 'styled-components'

const vars = css`
  /* VARIABLES */
  :root {
    --baby: #3fb0ac;
    --blood: hsl(0, 100%, 18%);
    --deep: #173e43;
    --gold: #d7a150;
    --color-text: #252525;
    --color-light: #dddfd4;
    --color-success: #067973;
    --color-success-bg: #f5fffe;
    --color-error: #b71540;
    --color-error-bg: #fdeff3;
    --color-shadow: rgba(23, 11, 41, 0.25);
    --font-base-family: 'Quattrocento', -apple-system, BlinkMacSystemFont,
      'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue',
      sans-serif;
    --font-heading-family: 'Cinzel', -apple-system, BlinkMacSystemFont,
      'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue',
      sans-serif;
    --metric-rhythm: 2rem;
    --metric-gutter: 2rem;
    --metric-box-padding: 1rem 1rem;
    --metric-interaction-padding: 0.6rem 0.6rem;
  }
`

export default vars
